<div class="dialog-header">
  <div class="title d-flex">
    <div *ngIf="icon" class="square-icon">
      <mat-icon [svgIcon]="icon"></mat-icon>
    </div>
    <ng-container *ngIf="!icon">
      <mat-icon
        class="status"
        *ngIf="status === LocationCardStatus.PENDING"
        svgIcon="hourglass"
      >
      </mat-icon>
      <mat-icon
        class="success"
        *ngIf="status === LocationCardStatus.SUCCESS"
        svgIcon="done"
      >
      </mat-icon>
      <mat-icon
        class="warning"
        *ngIf="status === LocationCardStatus.WARNING"
        svgIcon="info"
      >
      </mat-icon>
    </ng-container>
    <ng-container *ngIf="locationMode; else nonLocationMode">
      <div>
        <h3 *ngIf="title">{{ title }}</h3>
        <p>
          <span class="notranslate">
            {{ location?.name }}
            <ng-container *ngIf="location?.storeCode">
              - {{ location?.storeCode }}
            </ng-container>
            <ng-container *ngIf="location?.state">
              - {{ location?.state }}
            </ng-container>
            <ng-container *ngIf="countryName">
              , {{ countryName }}
            </ng-container>
          </span>
          <span>{{ ' ' }}</span>
          <span
            class="chips verify"
            *ngIf="location?.verificationStatus === 'VERIFIED'"
          >
            {{ lang === 'ar' ? 'مثبت' : 'Verified' }}
          </span>
          <span
            class="chips review"
            *ngIf="location?.verificationStatus === 'UNDER_REVIEW'"
          >
            {{ lang === 'ar' ? 'تحت المراجعة' : 'Under Review' }}
          </span>
          <span
            class="chips review"
            *ngIf="location?.verificationStatus === 'IN_PROGRESS'"
          >
            {{ lang === 'ar' ? 'جاري التحقق' : 'Verification in Progress' }}
          </span>
          <span
            class="chips blocked"
            *ngIf="location?.verificationStatus === 'DISABLED'"
          >
            {{ lang === 'ar' ? 'معطل' : 'Disabled' }}
          </span>
          <span
            class="chips blocked"
            *ngIf="location?.verificationStatus === 'EXPIRED'"
          >
            {{ lang === 'ar' ? 'انتهت صلاحية التكامل' : 'Integration Expired' }}
          </span>
          <span
            class="chips blocked"
            *ngIf="location?.verificationStatus === 'SUSPENDED'"
          >
            {{ lang === 'ar' ? 'معلق' : 'Suspended' }}
          </span>
          <span
            class="chips blocked"
            *ngIf="location?.verificationStatus === 'CONFLICT'"
          >
            {{ lang === 'ar' ? 'اختلاف في المليكة' : 'Ownership Conflict' }}
          </span>
          <span
            class="chips blocked"
            *ngIf="location?.verificationStatus === 'REQUIRED'"
          >
            {{ lang === 'ar' ? 'مطلوب التحقق' : 'Verification Required' }}
          </span>
          <span
            class="chips blocked"
            *ngIf="location?.verificationStatus === 'NOT_FOUND'"
          >
            {{ lang === 'ar' ? 'غير موجود' : 'Not Found' }}
          </span>
          <span
            class="chips blocked"
            *ngIf="location?.verificationStatus === 'DUPLICATE'"
          >
            {{ lang === 'ar' ? 'مكرر' : 'Duplicated' }}
          </span>
        </p>
      </div>
    </ng-container>

    <ng-template #nonLocationMode>
      <div>
        <h3 *ngIf="title">{{ title }}</h3>
        <p
          *ngIf="subTitle"
          [ngClass]="!isSubtitleTranslatable ? 'notranslate' : ''"
        >
          {{ subTitle }}
        </p>
      </div>
    </ng-template>
  </div>
  <button
    mat-icon-button
    color="primary"
    [disabled]="readOnly"
    [disableRipple]="readOnly"
    (click)="closeDialogClicked()"
  >
    <mat-icon svgIcon="close-icon"></mat-icon>
  </button>
</div>
